/*jQuery(window).load(function(){
  
  
  if (!!$.cookie('popup')) {
   console.log( "cookie exist!" );// have cookie
      $('.signup-wrapper').hide();
  } else {
   console.log( "cookie no exist!" );// no cookie
    $('.signup-wrapper').show();
  }
});*/

jQuery( document ).ready(function($) {
  console.log( "document ready!" );

  
});

jQuery( document ).ready(function($) {
  
  	setTimeout(function(){
   		$('.signup-wrapper').show();// or fade, css display however you'd like.
	}, 5000);
  
  	$("button.close.popup__close").click(function(e) {
			e.stopPropagation();
			$('.signup-wrapper').hide();
	});
  
  
  
});



(function($) {

  $(document).ready(function() {
	
    var width = $(window).width();
    
    if ($(window).width() < 768) {

    	$('.mobile-review').remove();
      $('#shopify-section-collection__sidebar + .has-sidebar-option').css({ width: width});
    }

  })

})(jQuery);



jQuery(document).ready(function($) {
  function toggleFixed () {
    
    var $sticky = $('.sticky');
  	var $stickyrStopper = $('.sticky-stopper');
  	if (!!$sticky.offset()) { // make sure ".sticky" element exists

    var width = $sticky.parent().width();
    var generalSidebarHeight = $sticky.innerHeight();
    var stickyTop = $sticky.offset().top;
    var stickOffset = 100;
    var stickyStopperPosition = $stickyrStopper.offset().top - 100;
    var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
    var diff = stopPoint + stickOffset - 100;

    $(window).scroll(function(){ // scroll event
      var windowTop = $(window).scrollTop(); // returns number

      if (stopPoint < windowTop) {
          $sticky.css({ position: 'sticky', top: stickOffset });
		  $sticky.removeClass('stuck');
		  $(".tab-accordion > h3").removeClass("active");
		  $(".q-content").slideUp(200);
		  
      } else if (stickyTop < windowTop+stickOffset) {
          $sticky.css({ position: 'fixed', top: stickOffset});
		  $sticky.addClass('stuck');
      } else {
          $sticky.css({position: 'absolute', top: 'initial'});
		  $sticky.removeClass('stuck');
      }
    });

  }  
}
  toggleFixed();
  
  
 $(window).resize(function() {
    toggleFixed();
  
});
});	


 

$(document).ready(function(){
  $(window).scroll(function(){
      if(($(window).scrollTop() > 150) && ($(window).scrollTop() + $(window).height() < $(document).height() - 400))
   { 
            $("#shopify-section-collection__sidebar-1").addClass('withfixed');
            //$(".sidebar.three.columns").addClass('fixedfilters');

    }
    else
    {
     $("#shopify-section-collection__sidebar-1").removeClass('withfixed');
     //$(".sidebar.three.columns").removeClass('fixedfilters');
   }

       })
  });	
